import React from "react";
import { faFacebook, faInstagram, faLinkedin, faYoutube } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import englishLogo from "../assets/Olympia_logo_english.png";
import greekLogo from "../assets/Olympia_logo_greek.png";
import { useSelector } from "react-redux";
import { getTranslation } from "../translations/getTranslations";

const About = () => {
  const language = useSelector(state => state.settings.language);
  const translation = key => getTranslation("aboutPage", key, language);

  const socialMediaLinks = {
    facebook: {
      url: "https://www.facebook.com/OlympiaElectronicsInternational",
      color: "#4867aa",
      icon: faFacebook,
    },
    instagram: {
      url: "https://www.instagram.com/olympiaelectronics/",
      color: "#e84a5a",
      icon: faInstagram,
    },
    linkedin: {
      url: "https://www.linkedin.com/company/olympia-electronics?trk=company_logo",
      color: "#0077b5",
      icon: faLinkedin,
    },
    youtube: {
      url: "https://www.youtube.com/channel/UCIINc4DGSYH_0loHJqwsgoQ",
      color: "#e44748",
      icon: faYoutube,
    },
  };

  const packageJson = require("../../package.json");
  const appVersion = packageJson.version;

  return (
    <div className={`text-textPrimary bg-backgroundPrimary flex h-full flex-col items-center p-10 text-lg`}>
      {/* Company Image */}
      <div className="my-10">
        <img
          src={language === "EN" ? englishLogo : greekLogo}
          alt="Olympia Electronics"
          className="w-[80vw] max-w-[400px]"
        />
      </div>

      {/* Contact Information Section */}
      <div className="mb-10 w-[80vw] max-w-[600px] text-center">
        <h2 className={`text-textPrimary mb-4 text-2xl font-bold`}>{translation("_contactInformation")}</h2>
        <p className="mb-2">
          <span className="font-semibold">{translation("_phone")}: </span>0030 2353 051200
        </p>
        <p className="mb-2">
          <span className="font-semibold">{translation("_email")}: </span>
          <a href="mailto:support@olympia-electronics.com" className={`text-textPrimary hover:underline`}>
            support@olympia-electronics.com
          </a>
        </p>
        <p>
          <span className="font-semibold">{translation("_website")}: </span>
          <a href="https://www.olympia-electronics.com" className={`text-textPrimary hover:underline`}>
            www.olympia-electronics.com
          </a>
        </p>
      </div>

      {/* Version and Copyright Info */}
      <div className="mb-10 w-[80vw] max-w-[600px] text-center">
        <h2 className={`text-textPrimary mb-4 text-2xl font-bold`}>{translation("_versionInformation")}</h2>
        <p className="mb-4">
          {translation("_version")}: {appVersion}
        </p>
        <p>© 2024 Olympia Electronics. {translation("_allRightsReserved")}</p>
      </div>

      {/* Social Media Links */}
      <div className="mb-10 w-[80vw] max-w-[600px] text-center">
        <h2 className={`text-textPrimary mb-4 text-2xl font-bold`}>{translation("_connectWithUs")}</h2>
        <div className="flex justify-center space-x-4">
          {Object.values(socialMediaLinks).map(media => (
            <a
              key={media.url}
              href={media.url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-2xl"
              style={{ color: media.color }}
            >
              <FontAwesomeIcon icon={media.icon} />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default About;
